import { Link } from "react-router-dom";
import { FaWhatsapp, FaEnvelope, FaPhoneAlt, FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-[#111111] text-gray-300 mt-16 w-full font-sans border-t-4 border-red-600">
      <div className="max-w-7xl mx-auto px-6 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {/* Brand & About */}
          <div className="flex flex-col space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <img src="/news.png" alt="Pratyaksha News Logo" className="h-10 sm:h-12 bg-white p-1 rounded" />
              <span className="text-2xl font-black text-white tracking-tight uppercase">Pratyaksha News</span>
            </Link>
            <p className="text-gray-400 leading-relaxed text-sm">
              Your trusted source for real local updates in Telugu and English. Stay informed with breaking stories, in-depth analysis, and exclusive reports from Andhra Pradesh, Telangana, and around the globe.
            </p>
            <div className="flex gap-4 pt-2">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-600 transition-colors text-white">
                <FaFacebookF size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-400 transition-colors text-white">
                <FaTwitter size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-pink-600 transition-colors text-white">
                <FaInstagram size={18} />
              </a>
              <a href="https://youtube.com/@realnews.c?si=jEgHw0dg09c-wm6U" target="_blank" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-red-600 transition-colors text-white">
                <FaYoutube size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links - Categorized */}
          <div>
            <h4 className="text-white text-lg font-bold mb-6 uppercase tracking-wider flex items-center">
              <span className="w-2 h-2 bg-red-600 mr-3"></span> Categories
            </h4>
            <ul className="grid grid-cols-2 gap-y-3 gap-x-4 text-sm font-medium">
              <li><a href="https://www.pratyakshanews.com/latest" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors flex items-center"><span className="text-red-600 mr-2">›</span> Latest</a></li>
              <li><a href="https://www.pratyakshanews.com/category/politics" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors flex items-center"><span className="text-red-600 mr-2">›</span> Politics</a></li>
              <li><a href="https://www.pratyakshanews.com/category/cinema" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors flex items-center"><span className="text-red-600 mr-2">›</span> Cinema</a></li>
              <li><a href="https://www.pratyakshanews.com/category/sports" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors flex items-center"><span className="text-red-600 mr-2">›</span> Sports</a></li>
              <li><a href="https://www.pratyakshanews.com/category/business" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors flex items-center"><span className="text-red-600 mr-2">›</span> Business</a></li>
              <li><a href="https://www.pratyakshanews.com/category/career" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors flex items-center"><span className="text-red-600 mr-2">›</span> Career</a></li>
              <li><a href="https://www.pratyakshanews.com/category/family" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors flex items-center"><span className="text-red-600 mr-2">›</span> Family</a></li>
            </ul>
          </div>

          {/* Useful Links */}
          <div>
             <h4 className="text-white text-lg font-bold mb-6 uppercase tracking-wider flex items-center">
              <span className="w-2 h-2 bg-red-600 mr-3"></span> Print Media
            </h4>
            <ul className="space-y-3 text-sm font-medium">
              <li><a href="https://www.epaper.pratyakshanews.com/" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors block py-1 border-b border-gray-800">E-Paper</a></li>
              <li><a href="https://www.pratyakshanews.com/gallery" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors block py-1 border-b border-gray-800">Photo Gallery</a></li>
              <li><a href="https://www.pratyakshanews.com/video" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors block py-1 border-b border-gray-800">Video Highlights</a></li>
              <li><Link to="/admin/login" className="hover:text-red-500 transition-colors block py-1 border-b border-gray-800">Admin Portal</Link></li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h4 className="text-white text-lg font-bold mb-6 uppercase tracking-wider flex items-center">
              <span className="w-2 h-2 bg-red-600 mr-3"></span> Contact Us
            </h4>
            <div className="space-y-4">
              <a href="mailto:pratyakshanewspaper@gmail.com" className="flex items-start gap-4 group">
                <div className="w-10 h-10 rounded bg-gray-800 flex items-center justify-center group-hover:bg-red-600 transition-colors shrink-0">
                  <FaEnvelope className="text-white" />
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-gray-500 uppercase font-bold tracking-wider">Email Us</span>
                  <span className="text-sm font-medium text-gray-300 group-hover:text-white transition-colors">pratyakshanewspaper@gmail.com</span>
                </div>
              </a>
              
              <a href="tel:+919299991059" className="flex items-start gap-4 group">
                <div className="w-10 h-10 rounded bg-gray-800 flex items-center justify-center group-hover:bg-red-600 transition-colors shrink-0">
                  <FaPhoneAlt className="text-white" />
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-gray-500 uppercase font-bold tracking-wider">Call Us</span>
                  <span className="text-sm font-medium text-gray-300 group-hover:text-white transition-colors">+91 92999 91059</span>
                </div>
              </a>

              <a href="https://wa.me/919299991059" target="_blank" rel="noopener noreferrer" className="flex items-start gap-4 group">
                <div className="w-10 h-10 rounded bg-gray-800 flex items-center justify-center group-hover:bg-green-600 transition-colors shrink-0">
                  <FaWhatsapp className="text-white" size={20} />
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-gray-500 uppercase font-bold tracking-wider">WhatsApp</span>
                  <span className="text-sm font-medium text-gray-300 group-hover:text-white transition-colors">Message Us</span>
                </div>
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* Footer Bottom */}
      <div className="bg-black py-6 border-t border-gray-900">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Pratyaksha News. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-white transition-colors">About Us</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
